module.exports = {
	DATA_TOPIC: [
		{ name: 'cm', name_seo: 'CM情報｜ピザハット', url: '/topic/cm/library'},
		{ name: 'margherita', name_seo: 'ご愛顧感謝セール｜ピザハット', url: '/topic/margherita/takeout'},
		{ name: 'autumn', name_seo: 'HALLOWEENウィーク｜ピザハット', url: '/topic/autumn/halloween'},
		{ name: 'campaign', name_seo: 'Twitterキャンペーン｜ピザハット', url: '/topic/campaign/20221021twitter'},
		{ name: 'one_person', name_seo: 'おひとり様用ワンコインピザ｜ピザハット', url: '/topic/one_person/takeout'},
		{ name: 'tbs', name_seo: 'ジョブチューン｜ピザハット', url: '/topic/tbs/jobtune3050'},
		{ name: 'hm5h', name_seo: '｢ヒプノシスマイク｣キャンペーン｜ピザハット', url: '/topic/hm5h/anniversary'},
		{ name: 'gogo', name_seo: 'GO！GO！HUTセール｜ピザハット', url: '/topic/gogo/hutsale'},
		{ name: 'choice', name_seo: '選べる｢2枚目無料タダ得セット｣｜ピザハット', url: '/topic/choice/tadatoku'},
		{ name: 'nimaime', name_seo: 'ピザ2枚目無料タダ得セット｜ピザハット', url: '/topic/nimaime/tadatoku'},
		{ name: 'rakutenpay', name_seo: '楽天ペイの日｜ピザハット', url: '/topic/rakutenpay/day'},
		{ name: 'notice', name_seo: '商品価格改定のお知らせ｜ピザハット', url: '/topic/notice/price_revision'},
		{ name: 'pizza', name_seo: 'ピザ全品デリバリー30%OFF､お持ち帰り50%OFF｜ピザハット', url: '/topic/pizza/zenpin'},
		{ name: 'app', name_seo: 'アプリ注文がおトク｜ピザハット', url: '/topic/app/5off'},
		{ name: 'membership', name_seo: 'HUT REWARDS｜ピザハットメンバーシッププログラム', url: '/topic/membership/hutrewards'},
		{ name: 'ricepizza', name_seo: 'ごはんピザMYBOX｜ピザハット', url: '/topic/ricepizza/mybox'},
		{ name: 'set', name_seo: 'おひとりさまピザセット｢MY BOX｣｜ピザハット', url: '/topic/set/mybox'},
		{ name: 'choice_set', name_seo: '選べるサイドセット｜ピザハット', url: '/topic/choice_set/side_menu'},
		{ name: 'chicken', name_seo: 'ウイングストリート｜ピザハット姉妹ブランド', url: '/topic/chicken/wingstreet'},
		{ name: 'hut_party', name_seo: 'ハットパーティー｜ピザハット', url: '/topic/hut_party/group_set'},
		{ name: 'hutday', name_seo: 'ハットの日｜ピザハット', url: '/topic/hutday/takeout'},
		{ name: 'message', name_seo: 'ピザ焼き上がりをLINEでお知らせ｜ピザハット', url: '/topic/message/line'},
		{ name: 'payment', name_seo: 'キャッシュレス決済｜ピザハット', url: '/topic/payment/cashless'},
		{ name: 'jp', name_seo: '便利でおトクなアプリ｜ピザハット', url: '/topic/jp/pizzahut_app'},
		{ name: 'special', name_seo: '選べるこだわりの生地｜ピザハット', url: '/topic/special/crust'},
		{ name: 'additional', name_seo: 'お好みのトッピングを追加できます｜ピザハット', url: '/topic/additional/toppings'},
		{ name: 'menu', name_seo: 'ピザメニュー一覧｜ピザハット', url: '/topic/menu/pizza'},
		{ name: 'branding', name_seo: 'いつだって想像以上｡｜ピザハット', url: '/topic/branding/2021'},
		{ name: 'goodtaste', name_seo: 'グッとおいしくプロジェクト｜ピザハット', url: '/topic/goodtaste/project'},
		{ name: 'okipizza', name_seo: '選べる受け取り方法｜ピザハット', url: '/topic/okipizza/service'},
		{ name: 'anshin', name_seo: '安心してご利用頂くための取り組み｜ピザハット', url: '/topic/anshin/torikumi'},
		{ name: 'jp', name_seo: 'アルバイト募集｜ピザハット', url: '/topic/jp/jobfind'}
	]
}



//////////////////
// WEBPACK FOOTER
// ./config/topic.js
// module id = lMZ4
// module chunks = 55